/**
 * Giao diện hiển thị danh sách hợp đồng khách hàng
 */
import { useEffect, useState } from "react";
import { notification, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import queryString from "query-string";
import { countContracts, getContractByStatus } from "features/contractSlice";
import TabContent from "./tabContent";

function ListContract() {
  const dispatch = useDispatch();
  const { query } = useSelector((state: any) => state.contractReducer);
  const [countContract, setCountContract] = useState<any>({});
  const [activeKey, setActiveKey] = useState<string>("1");

  const optionTabContracts = [
    {
      key: `1`,
      label: `Khách hàng đang dùng thử (${countContract?.trial ?? 0})`,
      children: (
        <TabContent
          activeKey={activeKey}
          record={{}}
          dataActiverHerd={{}}
          getContractByStatuss={getContractByStatuss}
        />
      ),
    },
    {
      key: `2`,
      label: `Khách đang thuê bao (${countContract?.doing ?? 0})`,
      children: (
        <TabContent
          activeKey={activeKey}
          record={{}}
          dataActiverHerd={{}}
          getContractByStatuss={getContractByStatuss}
        />
      ),
    },
    {
      key: `3`,
      label: `Khách dừng dịch vụ (${countContract?.stop ?? 0})`,
      children: (
        <TabContent
          activeKey={activeKey}
          record={{}}
          dataActiverHerd={{}}
          getContractByStatuss={getContractByStatuss}
        />
      ),
    },
  ];
  //Lấy danh sách hợp đồng
  function getContractByTabStatus(queryActive: any) {
    const payload = {
      query: queryString.stringify(
        {
          ...queryActive,
          populate:
            "contractDetails.servicePackageId.farmScaleTTNId farmScaleTTTId,userId,dataEntryClerk,techSupporter",
          sortBy: "createdAt:desc",
        },
        {
          skipNull: true,
          skipEmptyString: true,
        }
      ),
      skipUpdateReducer: false,
      callback: {
        success() {},
        failed(errorMessage: any) {
          notification.error({
            message: "Có lỗi xảy ra trong quá trình lấy danh sách!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(getContractByStatus(payload));
  }

  //Lấy danh sách hợp đồng
  function getContractByStatuss() {
    const payload = {
      query: queryString.stringify(
        {},
        {
          skipNull: true,
          skipEmptyString: true,
        }
      ),
      skipUpdateReducer: false,
      callback: {
        success(res: any) {
          setCountContract(res);
        },
        failed(errorMessage: any) {
          notification.error({
            message: "Có lỗi xảy ra trong quá trình lấy danh sách!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(countContracts(payload));
  }

  useEffect(() => {
    if (activeKey == "1") {
      getContractByTabStatus({
        ...query,
        statusQuery: "trial",
      });
    } else if (activeKey == "2") {
      getContractByTabStatus({
        ...query,
        statusQuery: "doing",
      });
    } else if (activeKey == "3") {
      getContractByTabStatus({
        ...query,
        statusQuery: "stop",
      });
    }
    getContractByStatuss();
  }, [query]);

  const handleChangeTab = (e: any) => {
    if (e === "1") {
      getContractByTabStatus({ statusQuery: "trial", page: 1, limit: 10 });
    } else if (e === "2") {
      getContractByTabStatus({ statusQuery: "doing", page: 1, limit: 10 });
    } else if (e === "3") {
      getContractByTabStatus({ statusQuery: "stop", page: 1, limit: 10 });
    }
    getContractByStatuss();
    setActiveKey(e);
  };
  return (
    <div>
      <Tabs
        defaultActiveKey={activeKey}
        items={optionTabContracts}
        onChange={(e) => handleChangeTab(e)}
      />
    </div>
  );
}

export default ListContract;
